import { Button } from '@cibli/shared';
import { Edit } from 'lucide-react';
import React from 'react';

interface EditableSectionProps {
  editable?: boolean;
  children: React.ReactNode;
  onEdit: () => void;
  buttonPosition?: 'left' | 'right';
  accentColor?: string;
  textColor?: string;
  className?: string;
  enablePageBreak?: boolean;
  /** When true, section can be split across pages (title on first chunk, border-only continuation blocks). */
  splitable?: boolean;
}

const EditableSection: React.FC<EditableSectionProps> = ({
  editable = true,
  children,
  onEdit,
  buttonPosition = 'right',
  className = '',
}) => {
  return (
    <div
      className={`${editable ? 'relative m-[-2px] rounded-lg border-2 border-primary border-dashed' : ''} ${className}`}
    >
      {editable && (
        <Button
          size="icon"
          variant="outline"
          className={`h-10 w-10 absolute -top-4 ${buttonPosition === 'left' ? '-left-4' : '-right-4'} bg-primary text-primary-foreground hover:bg-primary rounded-full p-2`}
          onClick={onEdit}
        >
          <Edit className="h-4 w-4" />
        </Button>
      )}
      {children}
    </div>
  );
};

export default EditableSection;
